import Title from "../../Title"
import DesertAnimation from "./DesertAnimation"

const Empty = () => (
  <div
    css={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "start",
      gap: 16,
      flex: 1,
    }}
  >
    <DesertAnimation />
    <Title title="Nothing to download" />
    <p
      css={{
        margin: 0,
        color: "#F2F3F5",
        fontSize: 17,
        textAlign: "center",
      }}
    >
      Scan a QR code to get the link.
    </p>
  </div>
)

export default Empty
